
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6 2a1 1 0 011-1h1a1 1 0 010 2H7a1 1 0 01-1-1zm5.986 2H2a1 1 0 000 2h8.132l-.91 1.363L7.5 9.086 5.707 7.293a1 1 0 00-1.414 1.414L6.086 10.5l-2.793 2.793a1 1 0 101.414 1.414L7.5 11.914l1.793 1.793a1 1 0 001.414-1.414L8.914 10.5l1.793-1.793c.047-.046.088-.098.125-.152L12.535 6H14a1 1 0 100-2H11.986zm3.862 5.308a1.5 1.5 0 011.304 0c.359.173.553.475.65.637.1.17.205.387.306.6l4.794 10.024a1 1 0 11-1.804.863L19.457 18h-5.914l-1.64 3.431a1 1 0 11-1.805-.863l4.778-9.99.016-.032c.101-.214.205-.43.306-.6.097-.163.291-.465.65-.638zM14.5 16h4l-2-4.182-2 4.182z","fill":"#fff"}})])
          )
        }
      }
    